/**
 * @file: cube事件通信
 * @author: jun.li@dmall.com
 */

class CubeEvent {
    callbacks: any = null;

    constructor() {
        this.callbacks = {};
    }

    on(eventType, callback) {
        var callbacks = this.callbacks;

        // 非注册事件不予处理
        callbacks[eventType] = callbacks[eventType] || [];
        callbacks[eventType].push(callback);
    }

    fire(eventType, param) {
        var callbacks = this.callbacks,
            i, callback;

        if (callbacks[eventType]) {
            for (i = 0; callback = callbacks[eventType][i]; ++i) {
                // 返回false后直接退出
                if (typeof callback === 'function' && callback.call(window, param) === false) {
                    return false;
                }
            }
        }
    }
}

export default CubeEvent;
